export default __webpack_public_path__ + "static/media/Bloodbeak.9b90c2d1.jpg";